import React, { useEffect, useState } from 'react';
import { Flag, Loader2, RefreshCw } from 'lucide-react';
import api from '@/lib/axios';

const ESTADOS = [
  ['aberta', 'Aberta', 'bg-amber-100 text-amber-800'],
  ['em_analise', 'Em análise', 'bg-blue-100 text-blue-800'],
  ['resolvida', 'Resolvida', 'bg-emerald-100 text-emerald-800'],
  ['rejeitada', 'Rejeitada', 'bg-slate-200 text-slate-700'],
];
const MOTIVO_LABEL = {
  fraude: 'Fraude', informacao_falsa: 'Informação falsa', viatura_inexistente: 'Viatura inexistente',
  contacto_suspeito: 'Contacto suspeito', ofensivo: 'Ofensivo', dados_pessoais: 'Dados pessoais',
  duplicado: 'Duplicado', preco_enganador: 'Preço enganador', outro: 'Outro',
};

export default function MarketplaceDenunciasPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin/marketplace/denuncias');
      setItems(res.data.items || []);
    } catch (e) {
      setErr(e.response?.data?.detail || 'Erro ao carregar denúncias.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const setEstado = async (id, estado) => {
    try {
      await api.put(`/admin/marketplace/denuncias/${id}`, { estado });
      setItems((list) => list.map((d) => (d.id === id ? { ...d, estado } : d)));
    } catch (e) {
      setErr(e.response?.data?.detail || 'Erro ao atualizar.');
    }
  };

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="marketplace-admin-denuncias-panel">
      <div className="mb-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Flag className="h-5 w-5 text-red-600" />
          <h2 className="text-base font-bold text-slate-900">Denúncias ({items.length})</h2>
        </div>
        <button onClick={load} className="inline-flex items-center gap-1 rounded-lg border border-slate-300 px-3 py-1.5 text-xs font-semibold text-slate-700" data-testid="denuncias-refresh">
          <RefreshCw className="h-3 w-3" /> Atualizar
        </button>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-sm text-slate-500"><Loader2 className="h-4 w-4 animate-spin" /> A carregar...</div>
      ) : items.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="denuncias-empty">Sem denúncias.</p>
      ) : (
        <div className="space-y-2">
          {items.map((d) => {
            const est = ESTADOS.find((e) => e[0] === d.estado) || ESTADOS[0];
            return (
              <div key={d.id} className="rounded-xl border border-slate-200 p-3" data-testid={`denuncia-${d.id}`}>
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div>
                    <p className="text-sm font-bold text-slate-900">{MOTIVO_LABEL[d.motivo] || d.motivo}</p>
                    <p className="text-xs text-slate-500">Anúncio: {d.publicacao_titulo || d.publicacao_id} · {String(d.created_at).slice(0, 16).replace('T', ' ')}</p>
                  </div>
                  <span className={`rounded-md px-2 py-1 text-[10px] font-bold uppercase ${est[2]}`}>{est[1]}</span>
                </div>
                {d.descricao && <p className="mt-2 rounded bg-slate-50 p-2 text-xs text-slate-600">{d.descricao}</p>}
                {d.email && <p className="mt-1 text-xs text-slate-400">Contacto: {d.email}</p>}
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {ESTADOS.map(([v, l]) => (
                    <button key={v} onClick={() => setEstado(d.id, v)} disabled={d.estado === v} className={`rounded-lg border px-2 py-1 text-[11px] font-semibold ${d.estado === v ? 'border-emerald-500 bg-emerald-50 text-emerald-700' : 'border-slate-300 text-slate-600 hover:bg-slate-50'}`} data-testid={`denuncia-${d.id}-set-${v}`}>
                      {l}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {err && <p className="mt-2 text-xs font-semibold text-red-600">{err}</p>}
    </section>
  );
}
